
export type BackupTaskType = "Periodic" | "OneTime";